"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonDatePicker = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
const DatePicker_1 = require("./internal/DatePicker/DatePicker");
const DatePickerOverlay_1 = require("./internal/DatePicker/DatePickerOverlay");
const OverlayTrigger_1 = require("./internal/OverlayTrigger");
const utils_1 = require("../utils");
const defaultTestId_1 = require("../utils/defaultTestId");
function ButtonDatePicker(props) {
    const { defaultOpen, disabled, trigger, onSelect, ...datePickerProps } = props;
    const state = (0, react_stately_1.useMenuTriggerState)({ isOpen: defaultOpen });
    const buttonRef = (0, react_1.useRef)(null);
    const { menuTriggerProps, menuProps } = (0, react_aria_1.useMenuTrigger)({ isDisabled: !!disabled }, state, buttonRef);
    const tid = (0, utils_1.useTestIds)(props, (0, OverlayTrigger_1.isTextButton)(trigger)
        ? (0, defaultTestId_1.defaultTestId)((0, OverlayTrigger_1.labelOr)(trigger, "buttonDatePicker"))
        : (0, OverlayTrigger_1.isNavLinkButton)(trigger)
            ? (0, defaultTestId_1.defaultTestId)(trigger.navLabel)
            : (0, OverlayTrigger_1.isIconButton)(trigger)
                ? trigger.icon
                : trigger.name);
    return ((0, jsx_runtime_1.jsx)(OverlayTrigger_1.OverlayTrigger, { ...props, menuTriggerProps: menuTriggerProps, state: state, buttonRef: buttonRef, ...tid, children: (0, jsx_runtime_1.jsx)(DatePickerOverlay_1.DatePickerOverlay, { overlayProps: menuProps, children: (0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, { ...datePickerProps, onSelect: (d) => {
                    onSelect(d);
                    state.close();
                }, ...tid.datePicker }) }) }));
}
exports.ButtonDatePicker = ButtonDatePicker;
